module.exports = "https://static.wmbcdn.com/uniweb/images/7c0fd55ac39e9c11ad2be6e2a024ddd1.svg";